import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

// Add a new client
export const addClient = async (clientData) => {
  try {
    const response = await axios.post(`${API_URL}/clients`, clientData);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// Get all clients
export const getAllClients = async (params = {}) => {
  try {
    const response = await axios.get(`${API_URL}/clients`, { params });
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// Get single client by ID
export const getClientById = async (id) => {
  try {
    const response = await axios.get(`${API_URL}/clients/${id}`);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// Update client
export const updateClient = async (id, clientData) => {
  try {
    const response = await axios.put(`${API_URL}/clients/${id}`, clientData);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// Delete client
export const deleteClient = async (id) => {
  try {
    const response = await axios.delete(`${API_URL}/clients/${id}`);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// Update client balance sheet
export const updateClientBalanceSheet = async (id, balanceSheetData) => {
  try {
    const response = await axios.put(`${API_URL}/clients/${id}/balance-sheet`, { client_balance_sheet: balanceSheetData });
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// Set/update a single Category or Sub-Category budget
export const updateCategoryBudget = async (id, budgetData) => {
  try {
    const response = await axios.put(`${API_URL}/clients/${id}/category-budget`, budgetData);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// Update client project status
export const updateProjectStatus = async (id, projectStatus) => {
  try {
    const response = await axios.put(`${API_URL}/clients/${id}/project-status`, { project_status: projectStatus });
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};
